import { createActions, createReducer } from 'reduxsauce'

import ConsultaRemuneracaoADMRHService from '../../servicos/ConsultaRemuneracaoADMRHService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaConsultaMembrosFuncoesGratificadasInicio: [],
    buscaConsultaMembrosFuncoesGratificadasErro: ['erro'],
    buscaConsultaMembrosFuncoesGratificadasSucesso: ['consultaMembrosFuncoesGratificadas'],
    limpar: [],
    setConsultaMembrosFuncoesGratificadasEstadoDT: ['estado'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    lista: [],
    dataSincronizacaoDados: null,
    estadoDT: {},
}

// Ação para busca completa
Creators.consultarQuadrosMembros = (filtro, tipoServidor) => {
    return dispatch => {
        dispatch(Creators.buscaConsultaMembrosFuncoesGratificadasInicio())
        let serv = new ConsultaRemuneracaoADMRHService()
        return serv
            .consultarQuadrosMembrosFgcc(filtro, tipoServidor)
            .then(response => dispatch(Creators.buscaConsultaMembrosFuncoesGratificadasSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaConsultaMembrosFuncoesGratificadasErro(error)))
    }
}

const buscaConsultaMembrosFuncoesGratificadasInicio = (state = INITIAL_STATE, action) => ({ ...state, carregando: true, erro: null })

const buscaConsultaMembrosFuncoesGratificadasErro = (state = INITIAL_STATE, action) => {
    return { ...state, erro: action.erro, carregando: false }
}

const buscaConsultaMembrosFuncoesGratificadasSucesso = (state = INITIAL_STATE, action) => {
    return {
        ...state,
        lista: action.consultaMembrosFuncoesGratificadas.resultado,
        dataSincronizacaoDados: action.consultaMembrosFuncoesGratificadas.dataSincronizacaoDados,
        carregando: false,
    }
}

const limpar = (state = INITIAL_STATE, action) => {
    return INITIAL_STATE
}

const setConsultaMembrosFuncoesGratificadasEstadoDT = (state = INITIAL_STATE, action) => {
    return { ...state, estadoDT: action.estado }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_CONSULTA_MEMBROS_FUNCOES_GRATIFICADAS_INICIO]: buscaConsultaMembrosFuncoesGratificadasInicio,
    [Types.BUSCA_CONSULTA_MEMBROS_FUNCOES_GRATIFICADAS_ERRO]: buscaConsultaMembrosFuncoesGratificadasErro,
    [Types.BUSCA_CONSULTA_MEMBROS_FUNCOES_GRATIFICADAS_SUCESSO]: buscaConsultaMembrosFuncoesGratificadasSucesso,
    [Types.LIMPAR]: limpar,
    [Types.SET_CONSULTA_MEMBROS_FUNCOES_GRATIFICADAS_ESTADO_DT]: setConsultaMembrosFuncoesGratificadasEstadoDT,
})
